module.exports = __webpack_public_path__ + "static/media/ember_spirit.2f011085.png";